// src/services/BudgetService.js
import api from "@/services/api";
import authHeader from "./authHeader";

export const budgetService = {
  async fetchAllBudgets() {
    return await api.get("/budgets", { headers: authHeader() });
  },
  fetchBudget(id) {
    return api.get(`/budgets/${id}`, { headers: authHeader() });
  },
  fetchCreateBudget(data) {
    return api.post("/budgets", data, { headers: authHeader() });
  },
  fetchUpdateBudget(id, data) {
    return api.put(`/budgets/${id}`, data, { headers: authHeader() });
  },
  fetchDeleteBudget(id) {
    return api.delete(`/budgets/${id}`, { headers: authHeader() });
  },
  fetchBudgetSearch(query = "") {
    console.log('ok8');
    return api.get(`/budgets/search`, { params: { search: query } });
  },
  fetchBudgetService(id) {
    return api.get(`/budgets/${id}/services`, { headers: authHeader() });
  },
};

export default budgetService;
